





















































































































































































import Vue from 'vue'
import { FETCH_ADDRESS_WEB_REPORT, SAVE_ADDRESS_WEB_REPORT } from '@/store/action-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'


interface ComponentData {
  reportData: any
  webReportPayload: any
  loading: boolean
  saveLoading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  optionObject: string[]
  optionRhythmus: string[]
  optionTag: string[]
  selectedTages: string[]
  option1: string[]

  option2: string[]
  option3: string[]
}

export default Vue.extend({
  name: 'WebReportReinigung',

  components: {
    ProgressCircular
  },

  props: {
    show: Boolean,
    selectedAddressId: Number
  },

  data (): ComponentData {
    return {
      reportData: undefined,
      webReportPayload: undefined,
      loading: false,
      saveLoading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      optionObject: [],
      optionRhythmus: [],
      optionTag: [],
      selectedTages: [],
      option1: [],

      option2: [],
      option3: []
    }
  },

  watch: {

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onCloseDialog (): void {
      this.$emit('close')
    },

    onTagesChange (data: string[]): void {
      this.webReportPayload.i_Wert012 = data.toString()
    },

    onSaveClick (): void {
      for (const item in this.webReportPayload) {
        if(this.webReportPayload[item] === true) {
          this.webReportPayload[item] = "Ja"
        } else if(this.webReportPayload[item] === false) {
          this.webReportPayload[item] = ""
        }
      }

      const payload: any =  {
        AddressId: this.selectedAddressId,
        FormName: "Pflichtenheft",
        Values: this.webReportPayload
      }

      this.saveWebReport(payload)
    },

    async saveWebReport (payload: any): Promise<void> {
      try {
        this.saveLoading = true
        const response: any = await this.$store.dispatch(SAVE_ADDRESS_WEB_REPORT, payload)
        this.saveLoading = false
        if(response.IsError) {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } else {
          this.$emit('saved')
        }
      } catch (e) {
        this.saveLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    setData (data: any): void {
      this.webReportPayload = data

      this.selectedTages = this.webReportPayload.i_Wert012.split(",")

      this.webReportPayload.i_Wert003 = this.webReportPayload.ZFAnzZimmer === '' || this.webReportPayload.ZFAnzZimmer === '0' ? this.webReportPayload.i_Wert003 : this.webReportPayload.ZFAnzZimmer
      this.webReportPayload.i_Wert004 = this.webReportPayload.ZFZimmer === '' || this.webReportPayload.ZFAnzZimmer === '0' ? this.webReportPayload.i_Wert004 : this.webReportPayload.ZFZimmer
      this.webReportPayload.i_Wert012 = this.webReportPayload.ZFEinsatztage === '' ? this.webReportPayload.i_Wert012 : this.webReportPayload.ZFEinsatztage
      this.webReportPayload.i_Wert005 = this.webReportPayload.ZFEtage === '' || this.webReportPayload.ZFEtage === '0' ? this.webReportPayload.i_Wert005 : this.webReportPayload.ZFEtage
      this.webReportPayload.i_Wert013 = this.webReportPayload.ZFEinsatzzeit === '' ? this.webReportPayload.i_Wert013 : this.webReportPayload.ZFEinsatzzeit
      this.webReportPayload.i_Wert018 = this.webReportPayload.ZFStockwerke === '' ? this.webReportPayload.i_Wert018 : this.webReportPayload.ZFStockwerke
      this.webReportPayload.i_Wert019 = this.webReportPayload.ZFStockwerke === '' ? this.webReportPayload.i_Wert019 : this.webReportPayload.ZFStockwerke
      this.webReportPayload.i_Wert015 = this.webReportPayload.ZFEinsatzrhythmus === '' ? this.webReportPayload.i_Wert015 : this.webReportPayload.ZFEinsatzrhythmus


      this.reportData = {
        headerLeft: [
          {id: 1, label: 'Adress-Nr.:', value: this.webReportPayload.Kundennummer},
          {id: 2, label: 'Name:', value: `${this.webReportPayload.KDVorname} ${this.webReportPayload.KDName}`},
          {id: 3, label: 'Objekt:', value: 'i_Wert005'},
          {id: 4, label: 'Zimmer:', value: 'i_Wert003', value2: 'i_Wert004'},
          {id: 5, label: 'Schlüssel:', value: 'i_Wert018', value2: 'i_Wert017' },
          {id: 6, label: 'Notiz:', value: 'i_Wert508'}
        ],

        headerRight: [
          {id: 7, label: 'Personal-Nr.:', value: this.webReportPayload.PFVorname},
          {id: 8, label: 'Verantwortlich:', value: this.webReportPayload.PFName},
          {id: 9, label: 'Rhythmus:', value: 'i_Wert015'},
          {id: 10, label: 'Tag(e):', value: 'i_Wert012'},
          {id: 11, label: 'Zeit:', value: 'i_Wert013'},
          {id: 12, label: '', value: 'i_Wert507'}
        ],

        detailListLeft: [
          {id: 1, detailLabel: 'i_Wert019', fieldList: [
              {id: 1, label: 'i_Wert021', value1: 'i_Wert022', value2: 'i_Wert023', value3: 'i_Wert024', value4: 'i_Wert025', value5: 'i_Wert026'},
              {id: 2, label: 'i_Wert033', value1: 'i_Wert034', value2: 'i_Wert035', value3: 'i_Wert036', value4: 'i_Wert037', value5: 'i_Wert038'},
              {id: 3, label: 'i_Wert045', value1: 'i_Wert046', value2: 'i_Wert047', value3: 'i_Wert048', value4: 'i_Wert049', value5: 'i_Wert050'},
              {id: 4, label: 'i_Wert057', value1: 'i_Wert058', value2: 'i_Wert059', value3: 'i_Wert060', value4: 'i_Wert061', value5: 'i_Wert062'},
              {id: 5, label: 'i_Wert069', value1: 'i_Wert070', value2: 'i_Wert071', value3: 'i_Wert072', value4: 'i_Wert073', value5: 'i_Wert074'},
              {id: 6, label: 'i_Wert081', value1: 'i_Wert082', value2: 'i_Wert083', value3: 'i_Wert084', value4: 'i_Wert085', value5: 'i_Wert086'},
              {id: 7, label: 'i_Wert093', value1: 'i_Wert094', value2: 'i_Wert095', value3: 'i_Wert096', value4: 'i_Wert097', value5: 'i_Wert098'},
              {id: 8, label: 'i_Wert105', value1: 'i_Wert106', value2: 'i_Wert107', value3: 'i_Wert108', value4: 'i_Wert109', value5: 'i_Wert110'},
              {id: 9, label: 'i_Wert117', value1: 'i_Wert118', value2: 'i_Wert119', value3: 'i_Wert120', value4: 'i_Wert121', value5: 'i_Wert122'},
              {id: 10, label: 'i_Wert129', value1: 'i_Wert130', value2: 'i_Wert131', value3: 'i_Wert132', value4: 'i_Wert133', value5: 'i_Wert134'},
              {id: 11, label: 'i_Wert141', value1: 'i_Wert142', value2: 'i_Wert143', value3: 'i_Wert144', value4: 'i_Wert145', value5: 'i_Wert146'},
              {id: 12, label: 'i_Wert153', value1: 'i_Wert154', value2: 'i_Wert155', value3: 'i_Wert156', value4: 'i_Wert157', value5: 'i_Wert158'},
              {id: 13, label: 'i_Wert165', value1: 'i_Wert166', value2: 'i_Wert167', value3: 'i_Wert168', value4: 'i_Wert169', value5: 'i_Wert170'},
              {id: 14, label: 'i_Wert177', value1: 'i_Wert178', value2: 'i_Wert179', value3: 'i_Wert180', value4: 'i_Wert181', value5: 'i_Wert182'},
              {id: 15, label: 'i_Wert189', value1: 'i_Wert190', value2: 'i_Wert191', value3: 'i_Wert192', value4: 'i_Wert193', value5: 'i_Wert194'}
            ]},
          {id: 2, detailLabel: 'i_Wert007', fieldList: [
              {id: 16, label: 'i_Wert200', value1: 'i_Wert201', value2: 'i_Wert202', value3: 'i_Wert203', value4: 'i_Wert204', value5: 'i_Wert205'},
              {id: 20, label: 'i_Wert213', value1: 'i_Wert214', value2: 'i_Wert215', value3: 'i_Wert216', value4: 'i_Wert217', value5: 'i_Wert218'},
              {id: 21, label: 'i_Wert225', value1: 'i_Wert226', value2: 'i_Wert227', value3: 'i_Wert228', value4: 'i_Wert229', value5: 'i_Wert230'},
              {id: 22, label: 'i_Wert237', value1: 'i_Wert238', value2: 'i_Wert239', value3: 'i_Wert240', value4: 'i_Wert241', value5: 'i_Wert242'},
              {id: 23, label: 'i_Wert249', value1: 'i_Wert250', value2: 'i_Wert251', value3: 'i_Wert252', value4: 'i_Wert253', value5: 'i_Wert254'},
              {id: 24, label: 'i_Wert261', value1: 'i_Wert262', value2: 'i_Wert263', value3: 'i_Wert264', value4: 'i_Wert265', value5: 'i_Wert266'},
              {id: 30, label: 'i_Wert272', value1: 'i_Wert273', value2: 'i_Wert274', value3: 'i_Wert275', value4: 'i_Wert276', value5: 'i_Wert277'},
              {id: 31, label: 'i_Wert284', value1: 'i_Wert285', value2: 'i_Wert286', value3: 'i_Wert287', value4: 'i_Wert288', value5: 'i_Wert289'},
              {id: 32, label: 'i_Wert296', value1: 'i_Wert297', value2: 'i_Wert298', value3: 'i_Wert299', value4: 'i_Wert300', value5: 'i_Wert301'},
              {id: 33, label: 'i_Wert308', value1: 'i_Wert309', value2: 'i_Wert310', value3: 'i_Wert311', value4: 'i_Wert312', value5: 'i_Wert313'}
            ]},
          {id: 3, detailLabel: 'i_Wert009', fieldList: [
              {id: 34, label: 'i_Wert320', value1: 'i_Wert321', value2: 'i_Wert322', value3: 'i_Wert323', value4: 'i_Wert324', value5: 'i_Wert325'},
              {id: 35, label: 'i_Wert332', value1: 'i_Wert333', value2: 'i_Wert334', value3: 'i_Wert335', value4: 'i_Wert336', value5: 'i_Wert337'},
              {id: 36, label: 'i_Wert344', value1: 'i_Wert345', value2: 'i_Wert346', value3: 'i_Wert347', value4: 'i_Wert348', value5: 'i_Wert349'},
              {id: 37, label: 'i_Wert356', value1: 'i_Wert357', value2: 'i_Wert358', value3: 'i_Wert359', value4: 'i_Wert360', value5: 'i_Wert361'},
              {id: 38, label: 'i_Wert368', value1: 'i_Wert369', value2: 'i_Wert370', value3: 'i_Wert371', value4: 'i_Wert372', value5: 'i_Wert373'},
              {id: 39, label: 'i_Wert380', value1: 'i_Wert381', value2: 'i_Wert382', value3: 'i_Wert383', value4: 'i_Wert384', value5: 'i_Wert385'},
              {id: 40, label: 'i_Wert393', value1: 'i_Wert394', value2: 'i_Wert395', value3: 'i_Wert396', value4: 'i_Wert397', value5: 'i_Wert398'},
              {id: 41, label: 'i_Wert405', value1: 'i_Wert406', value2: 'i_Wert407', value3: 'i_Wert408', value4: 'i_Wert409', value5: 'i_Wert410'},
              {id: 42, label: 'i_Wert417', value1: 'i_Wert418', value2: 'i_Wert419', value3: 'i_Wert420', value4: 'i_Wert421', value5: 'i_Wert422'},
              {id: 43, label: 'i_Wert430', value1: 'i_Wert431', value2: 'i_Wert432', value3: 'i_Wert433', value4: 'i_Wert434', value5: 'i_Wert435'}
            ]},
          {id: 4, detailLabel: 'i_Wert386', fieldList: [
              {id: 44, label: 'i_Wert442', value1: 'i_Wert443', value2: 'i_Wert444', value3: 'i_Wert445', value4: 'i_Wert446', value5: 'i_Wert447'},
              {id: 45, label: 'i_Wert448', value1: 'i_Wert449', value2: 'i_Wert450', value3: 'i_Wert451', value4: 'i_Wert452', value5: 'i_Wert453'},
              {id: 46, label: 'i_Wert454', value1: 'i_Wert455', value2: 'i_Wert456', value3: 'i_Wert457', value4: 'i_Wert458', value5: 'i_Wert459'},
              {id: 47, label: 'i_Wert460', value1: 'i_Wert461', value2: 'i_Wert462', value3: 'i_Wert463', value4: 'i_Wert464', value5: ''},
              {id: 48, label: 'i_Wert465', value1: 'i_Wert466', value2: 'i_Wert467', value3: 'i_Wert468', value4: 'i_Wert469', value5: ''},
              {id: 49, label: 'i_Wert470', value1: 'i_Wert471', value2: 'i_Wert472', value3: 'i_Wert473', value4: 'i_Wert474', value5: ''},
            ]},
        ],

        detailListRight: [
          {id: 1, detailLabel: 'i_Wert020', fieldList: [
              {id: 1, label: 'i_Wert027', value1: 'i_Wert028', value2: 'i_Wert029', value3: 'i_Wert030', value4: 'i_Wert031', value5: 'i_Wert032'},
              {id: 2, label: 'i_Wert039', value1: 'i_Wert040', value2: 'i_Wert041', value3: 'i_Wert042', value4: 'i_Wert043', value5: 'i_Wert044'},
              {id: 3, label: 'i_Wert051', value1: 'i_Wert052', value2: 'i_Wert053', value3: 'i_Wert054', value4: 'i_Wert055', value5: 'i_Wert056'},
              {id: 4, label: 'i_Wert063', value1: 'i_Wert064', value2: 'i_Wert065', value3: 'i_Wert066', value4: 'i_Wert067', value5: 'i_Wert068'},
              {id: 5, label: 'i_Wert075', value1: 'i_Wert076', value2: 'i_Wert077', value3: 'i_Wert078', value4: 'i_Wert079', value5: 'i_Wert080'},
              {id: 6, label: 'i_Wert087', value1: 'i_Wert088', value2: 'i_Wert089', value3: 'i_Wert090', value4: 'i_Wert091', value5: 'i_Wert092'},
              {id: 7, label: 'i_Wert099', value1: 'i_Wert100', value2: 'i_Wert101', value3: 'i_Wert102', value4: 'i_Wert103', value5: 'i_Wert104'},
              {id: 8, label: 'i_Wert111', value1: 'i_Wert112', value2: 'i_Wert113', value3: 'i_Wert114', value4: 'i_Wert115', value5: 'i_Wert116'},
              {id: 9, label: 'i_Wert123', value1: 'i_Wert124', value2: 'i_Wert125', value3: 'i_Wert126', value4: 'i_Wert127', value5: 'i_Wert128'},
              {id: 10, label: 'i_Wert135', value1: 'i_Wert136', value2: 'i_Wert137', value3: 'i_Wert138', value4: 'i_Wert139', value5: 'i_Wert140'},
              {id: 11, label: 'i_Wert147', value1: 'i_Wert148', value2: 'i_Wert149', value3: 'i_Wert150', value4: 'i_Wert151', value5: 'i_Wert152'},
              {id: 12, label: 'i_Wert159', value1: 'i_Wert160', value2: 'i_Wert161', value3: 'i_Wert162', value4: 'i_Wert163', value5: 'i_Wert164'},
              {id: 13, label: 'i_Wert171', value1: 'i_Wert172', value2: 'i_Wert173', value3: 'i_Wert174', value4: 'i_Wert175', value5: 'i_Wert176'},
              {id: 14, label: 'i_Wert183', value1: 'i_Wert184', value2: 'i_Wert185', value3: 'i_Wert186', value4: 'i_Wert187', value5: 'i_Wert188'},
              {id: 15, label: 'i_Wert195', value1: 'i_Wert196', value2: 'i_Wert197', value3: 'i_Wert198', value4: 'i_Wert199', value5: ''}
            ]},
          {id: 2, detailLabel: 'i_Wert008', fieldList: [
              {id: 16, label: 'i_Wert207', value1: 'i_Wert208', value2: 'i_Wert209', value3: 'i_Wert210', value4: 'i_Wert211', value5: 'i_Wert212'},
              {id: 20, label: 'i_Wert219', value1: 'i_Wert220', value2: 'i_Wert221', value3: 'i_Wert222', value4: 'i_Wert223', value5: 'i_Wert224'},
              {id: 21, label: 'i_Wert231', value1: 'i_Wert232', value2: 'i_Wert233', value3: 'i_Wert234', value4: 'i_Wert235', value5: 'i_Wert236'},
              {id: 22, label: 'i_Wert243', value1: 'i_Wert244', value2: 'i_Wert245', value3: 'i_Wert246', value4: 'i_Wert247', value5: 'i_Wert248'},
              {id: 23, label: 'i_Wert255', value1: 'i_Wert256', value2: 'i_Wert257', value3: 'i_Wert258', value4: 'i_Wert259', value5: 'i_Wert260'},
              {id: 24, label: 'i_Wert267', value1: 'i_Wert268', value2: 'i_Wert269', value3: 'i_Wert270', value4: 'i_Wert271', value5: ''},
              {id: 30, label: 'i_Wert278', value1: 'i_Wert279', value2: 'i_Wert280', value3: 'i_Wert281', value4: 'i_Wert282', value5: 'i_Wert283'},
              {id: 31, label: 'i_Wert290', value1: 'i_Wert291', value2: 'i_Wert292', value3: 'i_Wert293', value4: 'i_Wert294', value5: 'i_Wert295'},
              {id: 32, label: 'i_Wert302', value1: 'i_Wert303', value2: 'i_Wert304', value3: 'i_Wert305', value4: 'i_Wert306', value5: 'i_Wert307'},
              {id: 33, label: 'i_Wert314', value1: 'i_Wert315', value2: 'i_Wert316', value3: 'i_Wert317', value4: 'i_Wert318', value5: 'i_Wert319'}
            ]},
          {id: 3, detailLabel: 'i_Wert010', fieldList: [
              {id: 34, label: 'i_Wert326', value1: 'i_Wert327', value2: 'i_Wert328', value3: 'i_Wert329', value4: 'i_Wert330', value5: 'i_Wert331'},
              {id: 35, label: 'i_Wert338', value1: 'i_Wert339', value2: 'i_Wert340', value3: 'i_Wert341', value4: 'i_Wert342', value5: 'i_Wert343'},
              {id: 36, label: 'i_Wert350', value1: 'i_Wert351', value2: 'i_Wert352', value3: 'i_Wert353', value4: 'i_Wert354', value5: 'i_Wert355'},
              {id: 37, label: 'i_Wert362', value1: 'i_Wert363', value2: 'i_Wert364', value3: 'i_Wert365', value4: 'i_Wert366', value5: 'i_Wert367'},
              {id: 38, label: 'i_Wert374', value1: 'i_Wert375', value2: 'i_Wert376', value3: 'i_Wert377', value4: 'i_Wert378', value5: 'i_Wert379'},
              {id: 39, label: 'i_Wert387', value1: 'i_Wert388', value2: 'i_Wert389', value3: 'i_Wert390', value4: 'i_Wert391', value5: 'i_Wert392'},
              {id: 40, label: 'i_Wert399', value1: 'i_Wert400', value2: 'i_Wert401', value3: 'i_Wert402', value4: 'i_Wert403', value5: 'i_Wert404'},
              {id: 41, label: 'i_Wert411', value1: 'i_Wert412', value2: 'i_Wert413', value3: 'i_Wert414', value4: 'i_Wert415', value5: 'i_Wert416'},
              {id: 42, label: 'i_Wert423', value1: 'i_Wert425', value2: 'i_Wert426', value3: 'i_Wert427', value4: 'i_Wert428', value5: 'i_Wert429'},
              {id: 43, label: 'i_Wert436', value1: 'i_Wert437', value2: 'i_Wert438', value3: 'i_Wert439', value4: 'i_Wert440', value5: 'i_Wert441'},
            ]},
          {id: 4, detailLabel: 'i_Wert424', fieldList: [
              {id: 44, label: 'i_Wert475', value1: 'i_Wert476', value2: 'i_Wert477', value3: 'i_Wert478', value4: 'i_Wert479', value5: ''},
              {id: 45, label: 'i_Wert480', value1: 'i_Wert481', value2: 'i_Wert482', value3: 'i_Wert483', value4: 'i_Wert484', value5: ''},
              {id: 46, label: 'i_Wert485', value1: 'i_Wert486', value2: 'i_Wert487', value3: 'i_Wert488', value4: 'i_Wert489', value5: ''},
              {id: 47, label: 'i_Wert491', value1: 'i_Wert492', value2: 'i_Wert493', value3: 'i_Wert494', value4: 'i_Wert495', value5: ''},
              {id: 48, label: 'i_Wert490', value1: 'i_Wert496', value2: 'i_Wert497', value3: 'i_Wert498', value4: 'i_Wert499', value5: 'i_Wert500'},
              {id: 49, label: 'i_Wert503', value1: 'i_Wert501', value2: 'i_Wert502', value3: 'i_Wert504', value4: 'i_Wert505', value5: 'i_Wert506'},
            ]},
        ]
      }
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_ADDRESS_WEB_REPORT, this.selectedAddressId)
        this.loading = false
        if(response) {
          for (const key in response) {
            if(response[key] === 'Off') {
              response[key] = ''
            }
          }
          this.setData(response)
        }
      } catch (e) {
        this.loading = false
      }
    }
  },

  mounted () {
    this.optionObject = ['Büro', 'Wohnung', 'Haus', 'Andere']
    this.optionRhythmus = ['7 Tage', '14 Tage', '4 Wochen']
    this.optionTag = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag']

    for (let i = 1; i <= 10; i = i + 0.5) {
      this.option1.push(i.toFixed(1).toString())
    }


    for (let i = 0; i <= 50; i++) {
      this.option2.push(i.toString())
    }

    for (let i = 1; i <= 10 ; i++) {
      this.option3.push(i.toString())
    }

    this.fetchData()
  }
})
